import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LegalComponent } from './legal.component';
import { LegalTermsComponent } from './legal-terms.component';

import { LegalRoutingModule } from './legal-routing.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LegalRoutingModule,
  ],
  declarations: [
    LegalComponent,
    LegalTermsComponent
  ],
})
export class LegalModule { }



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/legal.module.ts